import * as ActionTypes from '../actions/types';
import xs from 'xstream';
import * as actions from '../actions';
import GENERAL_FUNCTIONS from '../utils/functions/functions';
import HEADER_FUNCTIONS from '../utils/functions/headers';
import sampleCombine from 'xstream/extra/sampleCombine';

const REQUEST_APPLICATION_SETTINGS = 'requestApplicationSettings';

export function requestApplicationSettings(sources) {
    const state$ = sources.STATE;
    const token$ = state$.map(state => state.applicationUser.accessToken);

    const request$ = sources.ACTION.filter(action => {
        return action.type === ActionTypes.FETCH_APPLICATION_SETTINGS;
    })
        .compose(sampleCombine(token$))
        .map(([action, token]) => ({
            url: `${GENERAL_FUNCTIONS.getBaseURL()}api/StaticApplicationSetting`,
            headers: HEADER_FUNCTIONS.headersWithTokenJson(token),
            category: REQUEST_APPLICATION_SETTINGS,
            method: 'GET',
        }));

    let httpResponse$ = sources.HTTP.select(REQUEST_APPLICATION_SETTINGS)
        .map(response => response.replaceError(err => xs.of(err)))
        .flatten()
        .map(response =>
            response.status === 200
                ? actions.fetchApplicationSettingsSuccess(response)
                : actions.fetchApplicationSettingsFailed(response),
        );

    return {
        ACTION: httpResponse$,
        HTTP: request$,
    };
}
